import {
  merchantNameFromAliasAddressApi,
  suspendCardApi,
} from "utils/AxiosUtil";
import { NetworkType } from "utils/network";

async function merchantNameFromAliasAddress(
  address: string,
  network: NetworkType,
) {
  try {
    const res = await merchantNameFromAliasAddressApi(address, network);
    return res.data;
  } catch (error) {
    console.log(`merchantNameFromAliasAddress error: `, error);
    throw error;
  }
}

async function suspendCard(cardNumber: string, network: NetworkType) {
  const res = await suspendCardApi(cardNumber, network);
  return res.data;
}
const card_services = { merchantNameFromAliasAddress, suspendCard };
export default card_services;
